export const formRows = [
  {
    span: 24,
    label: "用户名称",
    component: "AInput",
    placeholder: "请输入",
    prop: "nickName",
    allowClear: true,
  },
  {
    span: 24,
    label: "手机号码",
    component: "AInput",
    placeholder: "请输入",
    prop: "phonenumber",
    allowClear: true,
    sloteOptions: [
      {
        type: "icon",
        position: "addonAfter",
        sloteType: "mobile",
      },
    ],
  },
  {
    span: 24,
    label: "登录账号",
    component: "AInput",
    placeholder: "请输入",
    prop: "userName",
    allowClear: true,
    disabled: false,
  },
  {
    span: 24,
    label: "登录密码",
    component: "AInput",
    placeholder: "请输入",
    prop: "password",
    allowClear: true,
    disabled: false,
  },
  {
    span: 24,
    label: "归属部门",
    component: "ATreeSelect",
    placeholder: "请选择",
    prop: "deptId",
    allowClear: true,
    list: [],
  },
  {
    span: 24,
    label: "邮箱",
    component: "AInput",
    placeholder: "请输入",
    prop: "email",
    allowClear: true,
    sloteOptions: [
      {
        type: "icon",
        position: "addonAfter",
        sloteType: "mail",
      },
    ],
  },
  {
    span: 24,
    label: "用户状态",
    component: "Aswitch",
    prop: "useStatus",
    allowClear: true,
  },
  {
    span: 24,
    label: "所属角色",
    component: "NewAMultipleSelect",
    placeholder: "请选择",
    prop: "roleIds",
    allowClear: true,
    list: [],
  },
];
const reg1 = new RegExp(
  "^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$"
); // 校验手机号
export const formRules = {
  nickName: [
    { required: true, message: "用户名称不能空", trigger: "change" },
    {
      validator: (rule, val, callback) => {
        if (val.length > 50) {
          callback(new Error("名称过长"));
        } else {
          callback();
        }
      },
    },
  ],
  deptId: [{ required: true, message: "部门不能空", trigger: "change" }],
  phonenumber: [
    { required: true, message: "请输入手机号码", trigger: "change" },
    {
      validator: (rule, val, callback) => {
        if (!reg1.test(val)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      },
    },
  ],
  email: [{ required: false }, { type: "email", message: "请输入正确的邮箱!" }],
  //password: [{ required: true, message: "请输入登录密码", trigger: "change" }],
  userName: [{ required: true, message: "请输入登录账号", trigger: "change" }],
  role: [{ required: true, message: "请选择角色", trigger: "change" }],
};
